import { RAISE_API_V1_URL, RAISE_QUERY_URL } from "constants/endpoints";
import { get } from "services/api";

const BRAND_DETAILS_URL_TO_FETCH = `${RAISE_QUERY_URL}?type=paths&keywords=`;

export const getBrandDetails = async (brandName) => {
  const resp = await get(BRAND_DETAILS_URL_TO_FETCH + brandName);

  return resp.data;
};

export const getProductSummaries = async ({
  productSourceId,
  priceGreater,
  priceLower,
  page,
  perPage,
  order
}) => {
  const URL = `${RAISE_API_V1_URL}/product_summaries`;

  const resp = await get(URL, {
    params: {
      product_source_id: productSourceId,
      per: perPage,
      page,
      "q[price_gt]": priceGreater,
      "q[price_lt]": priceLower,
      "q[s]": order
    }
  });

  return resp.data;
};

export const getProductSource = async ({ brandSlug }) => {
  const URL = `${RAISE_API_V1_URL}/product_sources${brandSlug}`;

  const resp = await get(URL);

  return resp.data;
};
